import {
  pushEnrichedEventToDataLayerWithCleanUp,
  pushEventToDataLayer
} from "seneca-common/features/analytics";
import { withLogAndSwallowError } from "seneca-common/utils/senecaAnalytics";

export const analyticsLogUserClickedCTAOnSuccess = withLogAndSwallowError(
  userClickedCTAOnSuccess
);

export const analyticsLogUserConfirmedYearGroup = withLogAndSwallowError(
  userConfirmedYearGroup
);

export const analyticsLogUserCopiedActivationCode = withLogAndSwallowError(
  userCopiedActivationCode
);

export const analyticsLogUserClickedActivateTutoringNavbar =
  withLogAndSwallowError(userClickedActivateTutoringNavbar);

export const analyticsLogUserOpenedDiscord =
  withLogAndSwallowError(userOpenedDiscord);

const makeEventName = (event: string) => `s/tutoringJourney/${event}`;

function userClickedCTAOnSuccess() {
  pushEventToDataLayer({
    event: makeEventName("clicked-cta-on-success")
  });
}

function userConfirmedYearGroup(yearGroup: number | null = null) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName("confirmed-year-group"),
    payload: {
      yearGroup
    }
  });
}

function userCopiedActivationCode() {
  pushEventToDataLayer({
    event: makeEventName("copied-activation-code")
  });
}

function userClickedActivateTutoringNavbar() {
  pushEventToDataLayer({
    event: makeEventName("clicked-activate-nav")
  });
}

function userOpenedDiscord() {
  pushEventToDataLayer({
    event: makeEventName("opened-discord")
  });
}
